import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
var _excluded = ["appStore", "googlePlay"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { memo, useMemo } from "react";
import { PageContainer, GridBox, Box, Header, useMatchMedia, useSsr } from "@pochta/ui";
import isIOS from "../../../../helpers/isIOS";
import isMobileDevice from "../../../../helpers/isMobileDevice";
import { ErrorPageMain, ErrorPageWrapper } from "./ErrorPage.styles";
import ErrorPageLeftLinks from "./components/ErrorPageLeftLinks";
import ErrorPageRightLinks from "./components/ErrorPageRightLinks";
import ErrorPageLogo from "./components/ErrorPageLogo";
import ErrorPageApps from "./components/ErrorPageApps";

var AccessDeniedPage = function AccessDeniedPage(_ref) {
  var appStore = _ref.appStore,
      googlePlay = _ref.googlePlay,
      props = _objectWithoutProperties(_ref, _excluded);

  var mobile = useMatchMedia("mobile");

  var _useSsr = useSsr(),
      isSsr = _useSsr.isSsr;

  var isMobSafari = useMemo(function () {
    return isSsr ? false : isIOS() && isMobileDevice();
  }, [isSsr]);
  return /*#__PURE__*/React.createElement(ErrorPageMain, null, /*#__PURE__*/React.createElement(PageContainer, null, /*#__PURE__*/React.createElement(ErrorPageWrapper, null, /*#__PURE__*/React.createElement(ErrorPageLogo, {
    isMobile: mobile
  }), /*#__PURE__*/React.createElement(Header, {
    withPaddingTop: true,
    maxWidth: {
      xs: "420px",
      sm: "100%",
      xl: "100%"
    }
  }, "\u041E\u0448\u0438\u0431\u043A\u0430 403. \u041A \u044D\u0442\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u0437\u0430\u043F\u0440\u0435\u0449\u0451\u043D"), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Box, {
    mb: "16px"
  }, "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0434\u0440\u0443\u0433\u0438\u0435:"), /*#__PURE__*/React.createElement(GridBox, {
    row: true,
    gap: [0, 30]
  }, /*#__PURE__*/React.createElement(GridBox, {
    xs: 12,
    sm: 5,
    xl: 3
  }, /*#__PURE__*/React.createElement(ErrorPageLeftLinks, props)), /*#__PURE__*/React.createElement(GridBox, {
    xs: 12,
    sm: 5,
    xl: 4
  }, /*#__PURE__*/React.createElement(ErrorPageRightLinks, props)))), /*#__PURE__*/React.createElement(Box, {
    pt: "80px"
  }, "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043D\u0430\u0448\u0435 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435", /*#__PURE__*/React.createElement(ErrorPageApps, {
    isMobile: mobile,
    isMobSafari: isMobSafari,
    appStore: appStore,
    googlePlay: googlePlay
  })))));
};

export default /*#__PURE__*/memo(AccessDeniedPage);